import {INotification} from '@/firebase/notification';
import {IOnboardingUser} from '@/types/user';
import {createSlice} from '@reduxjs/toolkit';

export enum StatusTrackerTab {
  AIRPORT = 'airport',
  FLIGHT = 'flight'
}

export interface AppState {
  theme: string;
  language: string;
  statusTrackerToggle: boolean;
  statusTrackerTab: StatusTrackerTab;
  chatToggle: boolean;
  tmmChatToggle: boolean;
  notificationToggle: boolean;
  watchList: any;
  watchListReady: boolean;
  diversion: Record<string, string>;
  diversionReady: boolean;
  systemWatchList: Record<string, string>;
  systemWatchListReady: boolean;
  alertData: INotification[];
  alertDataReady: boolean;
  airportNoteReady: boolean;
  onboardingUsers: IOnboardingUser[];
  dataStatus: any[];
}

const initialState: AppState = {
  language: localStorage.getItem('i18nextLng') ?? 'en-US',
  theme: localStorage.getItem('theme') ?? '',
  statusTrackerToggle: true,
  statusTrackerTab: StatusTrackerTab.FLIGHT,
  chatToggle: false,
  tmmChatToggle: false,
  notificationToggle: false,
  watchList: {},
  watchListReady: false,
  diversion: {},
  diversionReady: false,
  systemWatchList: {},
  systemWatchListReady: false,
  alertData: [],
  alertDataReady: false,
  airportNoteReady: false,
  onboardingUsers: [],
  dataStatus: []
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
    setStatusTrackerToggle(state, action) {
      state.statusTrackerToggle = action.payload;
    },
    setStatusTrackerTab(state, action) {
      state.statusTrackerTab = action.payload;
    },
    setChatToggle(state, action) {
      state.notificationToggle = false;
      state.tmmChatToggle = false;
      state.chatToggle = action.payload;
    },
    setTMMChatToggle(state, action) {
      state.chatToggle = false;
      state.notificationToggle = false;
      state.tmmChatToggle = action.payload;
    },
    setNotificationToggle(state, action) {
      state.chatToggle = false;
      state.tmmChatToggle = false;
      state.notificationToggle = action.payload;
    },
    setWatchList(state, action) {
      state.watchList = action.payload;
      state.watchListReady = true;
    },
    setDiversion(state, action) {
      state.diversion = action.payload;
      state.diversionReady = true;
    },
    setSystemWatchList(state, action) {
      state.systemWatchList = action.payload;
      state.systemWatchListReady = true;
    },
    setAlertData(state, action) {
      state.alertData = action.payload;
      state.alertDataReady = true;
    },
    appendAlertData(state, action) {
      state.alertData.push(action.payload);
    },
    setAirportNoteReady(state, action) {
      state.airportNoteReady = action.payload;
    },
    setOnboardingUsers(state, action) {
      state.onboardingUsers = action.payload;
    },
    setDataStatus(state, action) {
      state.dataStatus = action.payload;
    }
  }
});

export const {
  setLanguage,
  setTheme,
  setStatusTrackerToggle,
  setStatusTrackerTab,
  setChatToggle,
  setTMMChatToggle,
  setNotificationToggle,
  setWatchList,
  setDiversion,
  setSystemWatchList,
  setAlertData,
  appendAlertData,
  setAirportNoteReady,
  setOnboardingUsers,
  setDataStatus
} = appSlice.actions;
export default appSlice.reducer;
